import json from './sprite.js';

export default {
    handle: 'SP_SPT4-Trees',
    label: 'es_SPT4-Trees_234684263',
    json,
};
